export enum SliderTypes {
  Primary,
  Secondary,
  Tertiary,
  Quaternary,
}
